import { render, staticRenderFns } from "./AutoCheckPlateChange.vue?vue&type=template&id=bd70b6b0&"
import script from "./AutoCheckPlateChange.vue?vue&type=script&lang=js&"
export * from "./AutoCheckPlateChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports